import script from "./Coupons.vue?vue&type=script&setup=true&lang=js"
export * from "./Coupons.vue?vue&type=script&setup=true&lang=js"

import "./Coupons.vue?vue&type=style&index=0&id=94dc4c00&scoped=true&lang=css"

import exportComponent from "/builds/skilltech-ph/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94dc4c00"]])

export default __exports__